import moment from "moment-timezone";

const getDifference = (createdDate) => {
  const today = new Date();
  const timeDifference = today.getTime() - new Date(createdDate).getTime();

  const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
  const hoursDifference = Math.floor(
    (timeDifference % (1000 * 3600 * 24)) / (1000 * 3600),
  );
  const minutesDifference = Math.floor(
    (timeDifference % (1000 * 3600)) / (1000 * 60),
  );

  const monthsDifference = Math.floor(daysDifference / 30.44);

  if (monthsDifference > 0) {
    const remainingDays = Math.floor(daysDifference % 30.44);
    return `${monthsDifference} month${monthsDifference > 1 ? "s" : ""} and ${remainingDays} day${remainingDays !== 1 ? "s" : ""} ago`;
  } else if (daysDifference > 0) {
    return `${daysDifference} day${daysDifference > 1 ? "s" : ""} ago`;
  } else if (hoursDifference > 0) {
    return `${hoursDifference} hour${hoursDifference > 1 ? "s" : ""} ago`;
  } else {
    return `${minutesDifference} minute${minutesDifference > 1 ? "s" : ""} ago`;
  }
};

const getMemberSince = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

export const getJobPriceWithLabel = (price, hiringType) => {
  if (!price) return '$0';

  const formattedPrice = formatNumberWithCommas(price);

  switch (hiringType) {
    case 1: // hourly
      return `$${formattedPrice}/hr`;
    case 3: // weekly
      return `$${formattedPrice}/weekly`;
    case 4: // Monthly
      return `$${formattedPrice}/month`;
    default:
      return `$${formattedPrice}`;
  }
};

// Usage example:
// getJobPriceWithLabel(item?.price, item?.hiring_type)

const formatNumberWithCommas = (number) => {
  if (number === undefined || number === null || number === "") {
    return "0";
  }

  const num = Number(number);
  if (isNaN(num)) {
    return "Invalid number";
  }

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const Commas = (number) => {
  if (number === undefined || number === null) {
    return "N/A";
  }

  const num = Math.abs(Number(number)); // ensures positive value

  if (isNaN(num)) {
    return "Invalid number";
  }

  const parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
};



const getTimeandhours = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  // Format the time
  const hour = date.getHours();
  const minutes = date.getMinutes();
  const period = hour >= 12 ? "PM" : "AM";
  const formattedHours = hour % 12 == 0 ? 12 : hour % 12; // Handle 12 AM/PM case
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Add leading zero if needed

  // return `${day} ${month} ${year} ${formattedHours}:${formattedMinutes} ${period}`;
  return `${formattedHours}:${formattedMinutes} ${period}`;
};

const getRemaindays = (targetDate) => {
  const saudiTimeZone = "Asia/Riyadh";

  // Parse targetDate string into a moment object and convert it to Saudi Arabia time
  const targetDateInSaudiTime = moment.tz(
    targetDate,
    "YYYY-MM-DD HH:mm:ss",
    saudiTimeZone,
  );

  // Get current time in Saudi Arabia time zone
  const nowInSaudiTime = moment.tz(moment(), saudiTimeZone);

  // Calculate the difference in day
  const daysDifference = targetDateInSaudiTime.diff(nowInSaudiTime, "day");

  if (daysDifference > 0) {
    return daysDifference + 1;
  } else if (daysDifference < 0) {
    return daysDifference;
  } else {
    return daysDifference;
  }
};

const getDeadlineDate = (duration_type, duration) => {
  const today = new Date();
  let deadline = new Date(today); // Clone the current date

  const type = String(duration_type);

  switch (type) {
    case "1": // Hour
      deadline.setHours(today.getHours() + Number(duration));
      break;
    case "2": // Days
      deadline.setDate(today.getDate() + Number(duration));
      break;
    case "3": // Weeks
      deadline.setDate(today.getDate() + Number(duration) * 7);
      break;
    case "4": // Months
      deadline.setMonth(today.getMonth() + Number(duration));
      break;
    default:
      return "Invalid duration type";
  }

  // 🧠 Format: "31 October 2025"
  const formattedDate = deadline.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return formattedDate;
};


const getDateFormate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // Change 'long' to 'short'
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};


const getTimeFormat = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  let hour = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amPm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return `${hour}:${minutes} ${amPm}`;
};


const getLocalTimeFormate = (dateString) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Convert UTC date to local timezone
  const localDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000 * -1);

  let hour = localDate.getHours();
  const minutes = String(localDate.getMinutes()).padStart(2, '0');
  const amPm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;

  return `${hour}:${minutes} ${amPm}`;
};


const getTime = (timeString) => {
  const [hour, minutes] = timeString.split(':').map(Number);

  if (isNaN(hour) || isNaN(minutes) || hour < 0 || hour > 23 || minutes < 0 || minutes > 59) {
    return "Invalid Time";
  }

  const amPm = hour >= 12 ? 'PM' : 'AM';
  const formattedHours = hour % 12 || 12; // Convert to 12-hour format
  const formattedMinutes = String(minutes).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes} ${amPm}`;
};


const getTotalDays = (start, end, startTime, endTime) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  // If startTime and endTime exist, set them
  if (startTime) {
    const [sh, sm] = startTime.split(':').map(Number);
    startDate.setHours(sh, sm, 0, 0);
  }
  if (endTime) {
    const [eh, em] = endTime.split(':').map(Number);
    endDate.setHours(eh, em, 0, 0);
  }

  const diffMs = endDate - startDate;

  if (diffMs <= 0) return '0 hours'; // fallback if end <= start

  const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const totalHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const totalMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  if (totalDays === 0) {
    // Same day → show hours and minutes
    return `${totalHours > 0 ? totalHours + 'h ' : ''}${totalMinutes ? `${totalMinutes}m` : ""}`;
  }

  return `${totalDays} day${totalDays > 1 ? 's' : ''}`;
};


const getBothDates = (start, end) => {
  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();
    return { day, month, year };
  };

  const startFormatted = formatDate(start);
  const endFormatted = formatDate(end);

  const endFormattedString = startFormatted.year === endFormatted.year
    ? `${endFormatted.day} ${endFormatted.month}`
    : `${endFormatted.day} ${endFormatted.month} `;

  return `From ${startFormatted.day} ${startFormatted.month} ${startFormatted.year} - ${endFormattedString} ${endFormatted.year}`;
};

const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Get month in "MM" format
  const day = currentDate.getDate().toString().padStart(2, '0'); // Get day in "DD" format
  return `${year}-${month}-${day}`; // Return the current date as "YYYY-MM-DD"
};

const getLastWeekDateRange = () => {
  const currentDate = new Date();
  const lastWeekStartDate = new Date(currentDate);
  lastWeekStartDate.setDate(currentDate.getDate() - 7); // Subtract 7 days to get the start of last week
  const year = lastWeekStartDate.getFullYear();
  const month = (lastWeekStartDate.getMonth() + 1).toString().padStart(2, '0');
  const day = lastWeekStartDate.getDate().toString().padStart(2, '0');
  const lastWeekStartDateFormatted = `${year}-${month}-${day}`;

  return lastWeekStartDateFormatted
};


const getPosttype = (type) => {
  let posttype = type == 1 ? 'PBP' : type == 3 ? 'PTJ' : type == 2 ? 'WBO' : 'No Idea';
  return posttype;
};

const today = new Date();

const maskAccountNumber = (number) => {
  if (!number) return "";
  const str = number.toString();
  const half = Math.floor(str.length / 2);
  return "x".repeat(str.length - half) + str.slice(-half);
};

const handleClientProfileNavigation = (type = 1) => {
  const industry_name = type == 1 ? "PBP Projects" : type == 2 ? "WBO Contests" : "PTJ Jobs";
  const category_name = type == 1 ? "Project Details" : type == 2 ? "Contest Details" : "Job Details";
  const subcategory_name = "Client Profile";

  const data = {
    industry_id: 0,
    industry_name: industry_name,
    category_id: 0,
    category_name: category_name,
    subcategory_id: 0,
    subcategory_name: subcategory_name,
    type: type,
  };

  console.log(data, 'data in handleClientProfileNavigation');
  localStorage.setItem('newTabState', JSON.stringify(data));
};

const formatDurationToHHMM = (duration) => {
  if (duration === undefined || duration === null || duration === "") return "0:00";

  let totalMinutes = 0;

  if (typeof duration === "string") {
    if (duration.includes(":")) {
      const parts = duration.split(":");
      if (parts.length >= 2) {
        const hours = parseInt(parts[0], 10) || 0;
        const minutesPart = parts[1];

        if (parts.length === 3) {
          return `${hours}:${minutesPart.padStart(2, "0")}`;
        }

        const mins = parseInt(minutesPart, 10) || 0;
        if (mins > 59) {
          totalMinutes = hours * 60 + Math.round(parseFloat("0." + minutesPart) * 60);
        } else {
          return `${hours}:${minutesPart.padStart(2, "0")}`;
        }
      }
    } else {
      totalMinutes = Math.round(parseFloat(duration) * 60);
    }
  } else if (typeof duration === "number") {
    totalMinutes = Math.round(duration * 60);
  }

  if (isNaN(totalMinutes)) return "0:00";

  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}:${String(m).padStart(2, "0")}`;
};

export {
  today,
  getDifference,
  getMemberSince,
  formatNumberWithCommas,
  getTimeandhours,
  getRemaindays,
  getDeadlineDate,
  getDateFormate,
  getTimeFormat,
  Commas,
  getTotalDays,
  getBothDates,
  getTime,
  getCurrentDate,
  getLastWeekDateRange,
  getPosttype,
  getLocalTimeFormate,
  maskAccountNumber,
  handleClientProfileNavigation,
  formatDurationToHHMM
};
